import React from 'react';
import { useEffect, useState, useContext, useMemo } from 'react';
import { Modal, Button, Table, Tab, Nav, Row, Col, OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { toast } from 'react-toastify';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    useReactTable,
} from '@tanstack/react-table';

import useRequest from '../helper/useRequest';
import { formatDate, formatTime } from '../helper/DateTimeFormater';
import Loader from '../helper/Loader';

import Separator from '../helper/Separator';
import TableHeader from '../helper/TableHeader';
import { customFilterFunction } from '../helper/CustomFilter';
import ModalCloseButton from '../helper/Modal/ModalCloseButton';
import AppContext from '../AppContext';
import Select from 'react-select';

import handleRequestResult from '../helper/HandleRequestResult';



const columnHelper = createColumnHelper();

const ModalForm = ({ modal, setModal, subscriptionAbo, quitAbo, cancelationDaysInAdvance }) => {
    const { request } = useRequest();
    const closeModal = () => {
        setModal(false);
    }
    const [aboStart, setAboStart] = useState();
    const [aboEnd, setAboEnd] = useState();
    const [newAboEnd, setNewAboEnd] = useState();
    const [onTime, setOnTime] = useState(false);

    useEffect(() => {
        if (!subscriptionAbo) return;

        var d = new Date(subscriptionAbo.Start);
        var dd = String(d.getDate()).padStart(2, '0');
        var mm = String(d.getMonth() + 1).padStart(2, '0');
        var yyyy = d.getFullYear();
        setAboStart(d.toLocaleDateString("de-DE", { weekday: 'long' }) + ", " + dd + '.' + mm + '.' + yyyy + ", ");

        d = new Date(subscriptionAbo.End);
        dd = String(d.getDate()).padStart(2, '0');
        mm = String(d.getMonth() + 1).padStart(2, '0');
        yyyy = d.getFullYear();
        setAboEnd(d.toLocaleDateString("de-DE", { weekday: 'long' }) + ", " + dd + '.' + mm + '.' + yyyy + ", ");

        var differenceInTime = new Date(subscriptionAbo.End).getTime() - new Date(subscriptionAbo.Start).getTime();
        var differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
        d = new Date(subscriptionAbo.End );
        d.setDate(d.getDate() + differenceInDays);
        dd = String(d.getDate()).padStart(2, '0');
        mm = String(d.getMonth() + 1).padStart(2, '0');
        yyyy = d.getFullYear();
        setNewAboEnd(d.toLocaleDateString("de-DE", { weekday: 'long' }) + ", " + dd + '.' + mm + '.' + yyyy + ", ");

        d = new Date();
        var cancelationDate = new Date(subscriptionAbo.End);
        cancelationDate.setDate(cancelationDate.getDate() - cancelationDaysInAdvance);
        if (d >= cancelationDate) {
            setOnTime(false);
        } else
        {
            setOnTime(true);
        }
    }, [subscriptionAbo]);

    if (!subscriptionAbo) return null;

    return (
        <Modal show={modal} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>Abonnement kündigen</Modal.Title>
                <ModalCloseButton onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>             
                <Row>
                    <Col>
                        Möchten Sie Ihr von {aboStart} bis {aboEnd} gebuchtes Abonnement kündingen? <br/>
                        Es wird eine Kündigungs-Bestätigung per Post und Mail zugesand.
                    </Col>
                </Row>              
                <Separator text="" />
                <Row className="mb-3">
                    <Col>
                        {onTime ? "Ihr gebuchtes Paket wird zum " +  aboEnd  + " gekündigt." : "Ihr gebuchtes Paket wurde nicht rechtzeitig, " +  cancelationDaysInAdvance  + " Tage im Voraus vor Ablauf des Abonnements, gekündigt, so dass es automatisch verlängert wurde. Ihr gebuchtes Paket wird zum " +  newAboEnd + " gekündigt."}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button variant="secondary" onClick={() => quitAbo(subscriptionAbo)}>
                    Kündigen
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

function Abo() {
    const { request } = useRequest();
    const [modal, setModal] = useState(false);
    const [cancelationDaysInAdvance, setCancelationDaysInAdvance] = useState(0);

    const [subscriptionAbo, setSubscriptionAbo] = useState(false);
    const [abos, setAbos] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(false);
    const [slotsList, setSlotsLIst] = useState([]);
    const [additionalContingentList, setAdditionalContingentList] = useState([]);
    const [userCount, setUserCount] = useState(0);
    const [key, setKey] = useState(0);
    const { User } = useContext(AppContext);

    const [presetNames, setPresetNames] = useState([]);

    
    useEffect(() => {
        getTimeslots();
    }, []);

    const getTimeslots = async () => {
        try {
            let result = await request("/Business/GetCancelationDaysInAdvance");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
                return;
            }
            else {
                setCancelationDaysInAdvance(json.cancelationDaysInAdvance);
            }
            result = await request("/Business/GetAbo");
            json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
            }
            else {
                setAbos(json.models);
                setSlotsLIst(json.slotsList);
                setAdditionalContingentList(json.additionalContingentList);
                setUserCount(json.userCount);
                setPresetNames(json.presetNames);

                var dn = new Date();

                for (var i = 0; i < json.models.length; i++) {
                    let start = new Date(json.models[i].Start);
                    let end = new Date(json.models[i].End);

                    if (dn >= start && dn <= end) {
                        setSelectedIndex(i);
                    }
                }
            }
        }
        catch (ex) {
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    };

    const quitAbo = async (item) => {
        try {
            let result = await request("/Business/QuitAbo", { aboID: item.AboID });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Das ausgewählte Abonnement wurde zum nächstmöglichen Termin gekündigt.");
            }
        }
        catch {
            toast.error("Die Kündigung des Abonnement ist fehlgeschlagen.");
        }
        finally {
            setModal(false);
            getTimeslots();
        }
    };

    const recallAboCacellation = async (AboID) => {
        console.log("recall cancellation", AboID);
        try {
            let result = await request("/Business/RecallAboCancellation", { aboId: AboID });
            let json = result.data;
            let success = () => {
                getTimeslots();
                toast.success("Die gewählte Kündigung wurde zurückgezogen.");
            }
            handleRequestResult(json, success);
        }
        catch {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const addAbo = async () => {
        try {
            location.pathname = "/Business/AdditionalAbo";
        }
        catch {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const addContingent = async (aboID) => {
        try {
            location.pathname = "/Business/AdditionalContingent/" + aboID;
        }
        catch {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const upgradeAbo = async (packageID) => {
        try {
            location.pathname = "/Business/UpgradeAbo/" + packageID;
        }
        catch {
            alert.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const checkCurrentAbo = () => {
        let currentAbo = {};
        let now = Date.now();
        
        for (let i = 0; i < abos.length; i++) {
            let start = new Date(abos[i].Start);
            let end = new Date(abos[i].End);

            if (start <= now && end >= now) {
                currentAbo = abos[i];
            }
        } 
        
        return currentAbo.Name == "Schnupper";
    }

    const checkAboName = (name) => {
        return presetNames.includes(name);
    }

    const now = new Date();

    const aboList = useMemo(() => {
        if (!abos) return [];
        return abos.map((item, index) => {
            return { value: item.AboID, label: formatDate(item.Start) + " - " + formatDate(item.End) };
        });
    }, [abos]);

    const selectedAbo = useMemo(() => {
        if (typeof abos[selectedIndex] === "undefined") return false;
        return abos[selectedIndex];
    }, [selectedIndex]);

    const status = useMemo(() => {
        if (selectedAbo.Canceled) return <div className="mb-0 alert alert-danger">Gekündigt</div>;

        if (now < new Date(selectedAbo.Start) || now > new Date(selectedAbo.End)) {
            if (now >= new Date(selectedAbo.Start)) {
                return <div className="mb-0 alert alert-warning">Abgelaufen</div>;
            } else {
                return <div className="mb-0 alert alert-warning">In Zukunft</div>;
            }
            
        } else {
            // return <Button type="button" id="quitAbo" variant="primary" onClick={() => { setModal(true); setSubscriptionAbo(selectedAbo); }}>Abonnement kündigen</Button>;
        }

    }, [selectedAbo]);

    if (abos === false) return <Loader />;

    /*
         <Nav variant="pills" className="flex-column">
                            {abos.map((item, index) => {
                                return <Nav.Item key={index}><Nav.Link eventKey={index}>{formatDate(item.Start)} - {formatDate(item.End)} <br />Suchradius: {(item.Radius != 999999999) ? item.Radius : "unbegrenzt"} km ({slotsList[index].length} / {item.Contingent + additionalContingentList[index]})</Nav.Link></Nav.Item>
                            })}
                        </Nav>
                        
  */
     

    return (
        <>
            <Tab.Container id="contingent-tabs" className="mb-3" defaultActiveKey={key}>
                <Row>
                    <Col sm={12}>
                        <div className="abo-info">
                            <h4>Gebuchte Pakete</h4>   
                            <div className="d-flex py-2 align-items-end justify-content-between">
                                <div className="abo-select">
                                    <label htmlFor="abos"><strong>Ausgewähltes Paket:</strong></label>
                                    <div className="d-flex align-items-center">
                                        <Select name="abos" classNamePrefix="bv-select" className="bv-select mr-2" value={{ value: selectedAbo.AboID, label: formatDate(selectedAbo.Start) + " - " + formatDate(selectedAbo.End) }} options={aboList} placeholder="Bitte auswählen" onChange={
                                            (values) => {
                                                const index = abos.findIndex(m => m.AboID == values.value);
                                                if (index > -1) {
                                                    setSelectedIndex(index);
                                                }
                                            }
                                        } />

                                        {status}
                                    </div>
                                </div>
                                {selectedIndex !== false && (
                                    <div className="btn-group">
                                        <Button type="button" id="addAbo" className="mr-1" variant="secondary" disabled={!User.IsAdmin} onClick={() => { addAbo(); }}>Abonnement hinzufügen</Button>
                                        {(
                                            now <= new Date(selectedAbo.End) &&
                                            <Button type="button" id="upgradeAbo" className="mr-1" variant="info" disabled={!User.IsAdmin} onClick={() => { upgradeAbo(selectedAbo.AboID); }}>Abonnement upgraden</Button>
                                        )}
                                        {(
                                            //now >= new Date(selectedAbo.Start) && //Zukünftige Abos dürfen doch bereits Kontingent erweitern
                                            now <= new Date(selectedAbo.End)) &&
                                            <Button type="button" id="addContingent" className="mr-1" variant="primary" disabled={!User.IsAdmin || checkCurrentAbo()} onClick={() => { addContingent(selectedAbo.AboID); }}>Kontingent erweitern</Button>
                                        }

                                        
                                        {selectedAbo.Canceled == false && (
                                            (now < new Date(selectedAbo.End)) && (
                                                (User.IsAdmin && <Button type="button" id="quitAbo" variant="danger" disabled={!User.IsAdmin} onClick={() => { setModal(true); setSubscriptionAbo(selectedAbo); }}>Abonnement kündigen</Button>)
                                            )
                                        )}

                                        {selectedAbo.Canceled == true && (
                                            (now < new Date(selectedAbo.End)) && (
                                                (User.IsAdmin && <Button type="button" id="recallAboCancellation" variant="warning" disabled={!User.IsAdmin} onClick={() => { recallAboCacellation(selectedAbo.AboID); }}>Kündigung zurückziehen</Button>)
                                            )
                                        )}
                                        </div>
                                    ) }
                                <div/>
                            </div>                            
                        </div>                     
                    </Col>
                    <Col sm={12}>
                        {selectedIndex !== false && (
                            <div>
                                <div>
                                    <div className="row bg-light py-2 align-items-center abo-info">
                                        {checkAboName(selectedAbo.Name) && (<div className="col-auto preset"><strong>Abo:</strong> {selectedAbo.Name}</div>)}
                                        <div className="col-auto date"><strong>Laufzeit:</strong> {formatDate(selectedAbo.Start)} - {formatDate(selectedAbo.End)}</div>
                                        <div className="col-auto contingent"><strong>Vorhandenes Kontingent:</strong> {slotsList[selectedIndex].length} / {selectedAbo.Contingent + additionalContingentList[selectedIndex]}</div>
                                    <div className="col-auto user"><strong>Anzahl Benutzer:</strong> {userCount} / {selectedAbo.User}</div>
                                        <div className="col-auto search"><strong>Suchradius:</strong> {(selectedAbo.Radius != 999999999) ? selectedAbo.Radius + " km" : "unbegrenzt"}</div>
                                    </div>
                                </div>
                                <div className="timeslots">
                                    <h4>Termine</h4>
                                    <ContingentTable aboObj={selectedAbo} slots={slotsList[selectedIndex]} />
                                </div>
                            </div>
                        ) }
                    </Col>
                </Row>
            </Tab.Container>     
            <ModalForm modal={modal} setModal={setModal} subscriptionAbo={subscriptionAbo} quitAbo={quitAbo} cancelationDaysInAdvance={cancelationDaysInAdvance} />
        </>
    );
}

function ContingentTable({ aboObj, slots }) {
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);
    
    const columns = [
        columnHelper.accessor('StatusString', {
            header: () => (
                <OverlayTrigger popperConfig={{
                    modifiers: {
                        name: "offset",
                        options: {
                            offset: [0, 20]
                        }
                    }
                }} placement="left" overlay={(
                    <Popover id="slot-status-info">
                        <Popover.Header as="h3">Status</Popover.Header>
                        <Popover.Body>
                            <div><span className="bookedCircle me-2"></span>offen</div>
                            <div><span className="bookedCircle booked me-2"></span>gebucht</div>
                            <div><span className="bookedCircle canceled me-2"></span>storniert</div>
                        </Popover.Body>
                    </Popover>
                )}>
                    <span>Status</span>
                </OverlayTrigger>
            ),
            cell: info => {
                let statusCircle = <span className="bookedCircle"></span>;
                if (info.getValue() == "gebucht") {
                    statusCircle = <span className="bookedCircle booked"></span>;
                }
                else if (info.getValue() == "storniert") {
                    statusCircle = <span className="bookedCircle canceled"></span>;
                }

                return (
                    <OverlayTrigger placement="left" overlay={<Tooltip>{info.getValue()}</Tooltip>}>
                        <>{statusCircle} {info.getValue()}</>
                    </OverlayTrigger>
                );
            },
            enableColumnFilter: true,
            filterFn: customFilterFunction,
            meta: {
                filterComponent: "select",
            }
        }),
        columnHelper.accessor('Appointment', {
            header: () => <span>Datum</span>,
            cell: info => formatDate(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeStart', {
            header: () => <span>Startzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeEnd', {
            header: () => <span>Endzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('OrganisationID', {
            header: () => <span>Schule</span>,
            cell: info => {
                return (
                    <div>{info.row.original.OrganisationName}, {info.row.original.Street} {info.row.original.HouseNo}, {info.row.original.PostCode} {info.row.original.City}</div>
                )
            },
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Grade', {
            header: () => <span>Stufe</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Class', {
            header: () => <span>Klasse</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Equipment', {
            header: () => <span>Ausstattung</span>,
            cell: info => info.getValue(),
            enableSorting: false,
            enableColumnFilter: true,
        }),
    ]

    const data = useMemo(() => {
        if (!slots) return slots;
        return slots.map(m => {
            const newItem = { ...m };
            newItem.Equipment = m.Equipment.map(m => m.Description).join(", ");

            newItem.OrganisationID = m.OrganisationName + ", " + m.Street + " " + m.HouseNo + ", " + m.PostCode + " " + m.City;

            return newItem;
        });
    }, [slots]);

    const reactTable = useReactTable({
        data: data || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    return (
        <Table striped responsive="xl">
            <thead>
                {reactTable.getHeaderGroups().map(headerGroup => (
                    <TableHeader key={headerGroup.id} table={reactTable} headerGroup={headerGroup} flexRender={flexRender} />
                ))}
            </thead>
            <tbody>
                {reactTable.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => {
                            return (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}

export default Abo;